export const CompleteBtn = ({position, onClick}) => {
    return (
        <button className={`header-btn ${position}`} onClick={onClick}>
            완료
        </button>
    )
}